export default {
    methods: {
        ucwords(string) {
            const words = string.split(" ");

            for (let index in words) {
                words[index] = words[index][0].toUpperCase() + words[index].substring(1);
            }

            return words.join(" ");
        }
    }
}
